'use strict';

/**
 * @ngdoc function
 * @name ntmApp.controller:preparationListController
 * @description
 * # preparationListController
 * Controller of the ntmApp
 */
angular.module('ntmApp')
  .controller('preparationListController', ['$scope', '$location', 'TALocationService', '$routeParams', 'TodaysAssignments', 'Constants', 'ConfirmationService',
      function ($scope, $location, TALocationService, $routeParams, TodaysAssignments, Constants, ConfirmationService) {

          $scope.todaysAssignments = new TodaysAssignments($scope, Constants.TodaysAssignments.Levels.PreparationList);

          $scope.back = function () {
              TALocationService.GoToTheHomePage();
          };

          $scope.selectCurrentDayActivities = function () {
              $scope.todaysAssignments.spreadedGroupsForTomorrow.tabIsSelected = false;
              $scope.todaysAssignments.spreadedGroupsForToday.tabIsSelected = true;

              $scope.todaysAssignments.selectedSpreadedGroups = $scope.todaysAssignments.spreadedGroupsForToday;
          };

          $scope.selectTomorrowsDayActivities = function () {
              $scope.todaysAssignments.spreadedGroupsForToday.tabIsSelected = false;
              $scope.todaysAssignments.spreadedGroupsForTomorrow.tabIsSelected = true;

              $scope.todaysAssignments.selectedSpreadedGroups = $scope.todaysAssignments.spreadedGroupsForTomorrow;
          };

          $scope.showActivitiesTabForTomorrow = function () {
              $scope.showRoomNotesTab = false;
          };

          $scope.showRoomNotesTabForTomorrow = function () {
              $scope.showRoomNotesTab = true;
          };

          $scope.showAddingContent = function () {
              $scope.showAddingElements = true;
          };

          $scope.hideAddingContent = function () {
              $scope.showAddingElements = false;
          };

          $scope.revertNoteEditing = function () {
              $scope.hideAddingContent();

              $scope.todaysAssignments.enteredRoomNote = '';
              $scope.todaysAssignments.selectedFacilityRoom = null;
          };

          $scope.revertSelectedNoteEditing = function (selectedNote) {
              if (selectedNote.initialNoteValue) {
                  selectedNote.note = selectedNote.initialNoteValue;
              }

              selectedNote.isEditMode = false;
          };

          $scope.selectFacilityRoom = function (roomNoteItem, itemIndex) {
              $scope.todaysAssignments.selectedFacilityRoom = roomNoteItem;
              $scope.selectedFacilityRoomItemIndex = itemIndex;
          };

          $scope.addRoomNote = function () {
              if ($scope.todaysAssignments.selectedFacilityRoom && $scope.todaysAssignments.enteredRoomNote && $scope.todaysAssignments.enteredRoomNote !== '') {
                  var roomNote = {
                      facilityCode: $scope.todaysAssignments.selectedFacilityRoom.facilityCode,
                      facilityName: $scope.todaysAssignments.selectedFacilityRoom.facilityName,
                      roomNumber: $scope.todaysAssignments.selectedFacilityRoom.roomNumber,
                      note: $scope.todaysAssignments.enteredRoomNote
                  };

                  $scope.todaysAssignments.UpdateRoomNote(roomNote, $scope.todaysAssignments.DBActions.Insert);

                  $scope.todaysAssignments.roomNotesDropdown.splice($scope.selectedFacilityRoomItemIndex, 1);

                  $scope.revertNoteEditing();
              }
          };

          $scope.updateSelectedNote = function (selectedNote) {
              $scope.todaysAssignments.UpdateRoomNote(selectedNote, $scope.todaysAssignments.DBActions.Update);

              selectedNote.isEditMode = false;
          };

          $scope.deleteSelectedNote = function (selectedNote) {

              var updateRoomNote = function () {
                  $scope.todaysAssignments.UpdateRoomNote(selectedNote, $scope.todaysAssignments.DBActions.Delete);
              };

              ConfirmationService.YesNoConfirmation("Are you sure you want to delete selected Room Note?", null, { no: 'No, cancel', yes: 'Yes, delete Room Note' })
                                 .Yes(function () {
                                     updateRoomNote();
                                 })
                                 .Ask();
          };

          $scope.editSelectedNote = function (selectedNote) {
              selectedNote.isEditMode = true;
              $scope.hideAddingContent();
          };

          function init() {
              $scope.todaysAssignments.LoadPreparationListData().then(function () {

                  if ($routeParams.facilityId && $routeParams.roomId) {
                      var existingRoomNote = $scope.todaysAssignments.roomNotesForTomorrow.firstOrDefault(function (roomNote) {
                          return roomNote.facilityCode === $routeParams.facilityId && roomNote.roomNumber === $routeParams.roomId;
                      });

                      if (existingRoomNote) {
                          $scope.selectTomorrowsDayActivities();
                          $scope.showRoomNotesTabForTomorrow();
                          $scope.editSelectedNote(existingRoomNote);
                      } else {
                          var roomNoteInDropdown = null;
                          var roomNoteIndexInDropdown = null;

                          $scope.todaysAssignments.roomNotesDropdown.forEach(function (roomNote, roomNoteIndex) {
                              if ($routeParams.facilityId === roomNote.facilityCode && $routeParams.roomId === roomNote.roomNumber) {
                                  roomNoteInDropdown = roomNote;
                                  roomNoteIndexInDropdown = roomNoteIndex;
                              }
                          });

                          if (roomNoteInDropdown) {
                              $scope.selectFacilityRoom(roomNoteInDropdown, roomNoteIndexInDropdown);
                              $scope.selectTomorrowsDayActivities();
                              $scope.showRoomNotesTabForTomorrow();
                              $scope.showAddingContent();
                          }
                      }
                  }

                  $scope.todaysAssignments.enteredRoomNote = '';
                  $scope.todaysAssignments.dataLoaded = true;
              });
          }

          init();

          $scope.$on('$destroy', function () {
              $scope.todaysAssignments.closeSignalRConnection();
          });

      }]);
